import React from 'react';
import Grid from '@mui/material/Grid';
import Sticker from './Sticker.js';
import data from './data.json';

const Nation = (props) => {
  const stickers = data[props.nation];
  const nationName = props.nation.replaceAll(' ', '');

  return (
    <div>
      <p className={'nationName ' + nationName}>{props.nation}</p>
      <Grid
        container
        spacing={1}
        id={nationName + 'background'}
        sx={{ scrollMarginTop: '80px' }}
      >
        {stickers.map((sticker, i) => (
          <Sticker key={i} img={sticker.url} title={sticker.title} />
        ))}
      </Grid>
    </div>
  );
};

export default Nation;
